import React from "react";
import './UserPointModal.scss';
import { Modal } from "react-bootstrap";
import PointsService from "../../../services/management/PointsService";
import UserPointModalState, { UserPointModalProps } from "./UserPointModal.models";
import moment from 'jalali-moment';

export default class UserPointModal extends React.PureComponent<UserPointModalProps, UserPointModalState> {

    pointsService: PointsService;
    constructor(props: any) {
        super(props);
        this.pointsService = new PointsService();
        this.state = { pointsDetails: { pointTitle: '', points: [] } };
    }

    componentDidMount = () => {
        this.getData();
    }

    componentDidUpdate = (prevProps: any) => {
        if (prevProps.parentId !== this.props.parentId)
            this.getData();
    }

    getData = () => {
        let self = this;
        if (this.props.parentId !== 0)
            self.pointsService.getDetailPoints({
                parentId: this.props.parentId
            }).then(function (response) {
                self.setState({ pointsDetails: response });
            });
    }

    render(): React.ReactNode {
        let { closeModal, showModal } = this.props;
        let { pointsDetails } = this.state;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>مشاهده جزئیات</label>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="user-point-modal-area" style={{ textAlign: "right" }} dir={"ltr"}>
                    <div className="tk-padding-top tk-padding-bottom">
                        <label> عنوان : {pointsDetails.pointTitle}</label>
                    </div>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>تاریخ دریافت</th>
                                <th>توضیحات</th>
                                <th>امتیاز</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pointsDetails.points.map((point, key) => {
                                return <tr key={key}>
                                    <td>
                                        {moment(point.dateOfUse).locale('fa').format('YYYY/MM/DD')}
                                    </td>
                                    <td>
                                        {point.description}
                                    </td>
                                    <td>
                                        {point.point}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-danger tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
    }
}